import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import { loginUser } from './login-user'
import { smp } from './smp'

export default new Vuex.Store({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    loginUser,
    smp
  },
  strict: process.env.NODE_ENV !== 'production'
})
